import styled from "styled-components"
import Button from "components/EvtKit/button/Button"
import { IoMdAddCircleOutline } from "react-icons/io"
import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import ProductSelector from "components/EvtKit/ProductSelector"

import { memo, useCallback } from "react"
import { Colors } from "themes/palette"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.palette.gray_ice};
  margin-top: 48px;
`

const PageTitleContainer = styled.div`
  width: 98%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CardContainer = styled.div`
  width: 98%;
  height: 540px;
  margin-top: 48px;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 0px 2px 6px 0px ${(props) => props.theme.palette.box_shadow};
  border-radius: 10px;
`

const CardContentContainer = styled.div`
  margin-top: 156px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
`

const ButtonContainer = styled.div`
  width: 330px;
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 24px 0;
`

const ProductContainer = styled.div`
  display: flex;
  width: 320px;
`

interface PageLayoutProps {
  title: string
  isInitialPage?: boolean
  buttonLabel?: string
  cardLabel?: string
  isLoading?: boolean
  hasTitleButton?: boolean
  onButtonClick?: () => void
  children: React.ReactNode
  handleSelectChange?: (value: string) => void
  selectedProduct?: string
  hasFilters?: boolean
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    title,
    isInitialPage = false,
    buttonLabel,
    children,
    cardLabel,
    hasTitleButton = false,
    isLoading = false,
    onButtonClick,
    handleSelectChange,
    selectedProduct,
    hasFilters = false
  } = props

  const onSelectChange = useCallback((product: string) => {
    handleSelectChange?.(product)
  }, [])

  return (
    <Container>
      <PageTitleContainer>
        <Heading variant="h3" color="gray-dark">
          {title}
        </Heading>

        {!isInitialPage && hasTitleButton && (
          <ButtonContainer>
            <Button
              label={buttonLabel}
              onClick={onButtonClick}
              iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
              className="background-gradient fill-width"
            />
          </ButtonContainer>
        )}
      </PageTitleContainer>

      {hasFilters && (
        <SelectContainer>
          <ProductContainer>
            <ProductSelector
              onChange={onSelectChange}
              value={selectedProduct || ""}
              label="Filtrar por produto"
              cleanFilter
            />
          </ProductContainer>
        </SelectContainer>
      )}

      {isLoading && <Spinner />}

      {!isLoading && (
        <>
          {isInitialPage && (
            <CardContainer>
              <CardContentContainer>
                <BodyText size="medium" weight="semi-bold" color="gray-dark">
                  {cardLabel}
                </BodyText>
                <ButtonContainer>
                  <Button
                    label={buttonLabel}
                    onClick={onButtonClick}
                    iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
                    className="background-gradient fill-width"
                  />
                </ButtonContainer>
              </CardContentContainer>
            </CardContainer>
          )}

          {!isInitialPage && <>{children}</>}
        </>
      )}
    </Container>
  )
}

export default memo(PageLayout)
